import { render } from "./FinancialBoard.vue?vue&type=template&id=11ec9231&scoped=true"
import script from "./FinancialBoard.vue?vue&type=script&lang=js"
export * from "./FinancialBoard.vue?vue&type=script&lang=js"

import "./FinancialBoard.vue?vue&type=style&index=0&id=11ec9231&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ec9231"]])

export default __exports__